import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../../../../types'
import { initialState } from '.'

const selectSlice = (state: RootState) => state.fuseSearch || initialState

export const selectFuseSearch = createSelector([selectSlice], state => state)
